import { SelectItem } from '@/app/components/ui/select';
import { COMPANY_ROLE_OPTIONS } from '@/lib/company-roles';

export function CompanyRoleSelectItems() {
  return COMPANY_ROLE_OPTIONS.map((option) => (
    <SelectItem key={option.value} value={option.value} textValue={option.label}>
      <span className="flex flex-col">
        <span className="font-medium">{option.label}</span>
        <span className="text-xs text-muted-foreground">{option.description}</span>
      </span>
    </SelectItem>
  ));
}
